module.exports = __webpack_public_path__ + "img/pethouse54.dbe113df.jpg";